import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';
import React from 'react';

import type { CodeInputAlign } from './CodeInput';
import { errorIconSx, errorTextSx, lineSx, messageSx, quietTextSx } from './codeMessageStyles';

export interface CodeRefusalProps {
  readonly id?: string;
  readonly message: string;
  readonly detail?: string | null;
  readonly align?: CodeInputAlign;
}

export const CodeRefusal: React.FC<CodeRefusalProps> = ({ id, message, detail = null, align = 'start' }) => (
  <Box id={id} role="alert" sx={messageSx(align)}>
    <Box sx={lineSx}>
      <ErrorOutlineIcon fontSize="small" sx={errorIconSx} />
      <Typography variant="highlight" component="p" sx={errorTextSx}>
        {message}
      </Typography>
    </Box>
    {detail !== null && (
      <Typography variant="label" component="p" sx={quietTextSx}>
        {detail}
      </Typography>
    )}
  </Box>
);
